/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TargetBoxOption } from './TargetBoxOption';
import {
    TargetBoxOptionFromJSON,
    TargetBoxOptionFromJSONTyped,
    TargetBoxOptionToJSON,
    TargetBoxOptionToJSONTyped,
} from './TargetBoxOption';
import type { EnumOption } from './EnumOption';
import {
    EnumOptionFromJSON,
    EnumOptionFromJSONTyped,
    EnumOptionToJSON,
    EnumOptionToJSONTyped,
} from './EnumOption';

/**
 * 
 * @export
 * @interface AdminStockAdjustLocationMoveInitResVo
 */
export interface AdminStockAdjustLocationMoveInitResVo {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    skuCode?: string;
    /**
     * 商品批次 goodsId
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    goodsId?: number;
    /**
     * 批次号（库存订单编号）
     * @type {string}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    batchNo?: string;
    /**
     * 来源箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    sourceBoxId?: number;
    /**
     * 来源箱唛/箱号
     * @type {string}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    sourceMarkNo?: string;
    /**
     * 来源箱存储方式：0 装箱保管 1 单独保管
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    sourceSeparateStore?: number;
    /**
     * 可调整数量（来源箱内该批次可用量）
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    adjustableQty?: number;
    /**
     * 是否允许选择单独保管（固定 true，与来源箱存储方式无关）
     * @type {boolean}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    allowSeparateStorage?: boolean;
    /**
     * 存储方式下拉
     * @type {Array<EnumOption>}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    storageMethodOptions?: Array<EnumOption>;
    /**
     * 装箱保管目标箱下拉（separateStore=0 时展示，同仓非单独保管库存箱）
     * @type {Array<TargetBoxOption>}
     * @memberof AdminStockAdjustLocationMoveInitResVo
     */
    targetBoxOptions?: Array<TargetBoxOption>;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationMoveInitResVo interface.
 */
export function instanceOfAdminStockAdjustLocationMoveInitResVo(value: object): value is AdminStockAdjustLocationMoveInitResVo {
    return true;
}

export function AdminStockAdjustLocationMoveInitResVoFromJSON(json: any): AdminStockAdjustLocationMoveInitResVo {
    return AdminStockAdjustLocationMoveInitResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveInitResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationMoveInitResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'batchNo': json['batchNo'] == null ? undefined : json['batchNo'],
        'sourceBoxId': json['sourceBoxId'] == null ? undefined : json['sourceBoxId'],
        'sourceMarkNo': json['sourceMarkNo'] == null ? undefined : json['sourceMarkNo'],
        'sourceSeparateStore': json['sourceSeparateStore'] == null ? undefined : json['sourceSeparateStore'],
        'adjustableQty': json['adjustableQty'] == null ? undefined : json['adjustableQty'],
        'allowSeparateStorage': json['allowSeparateStorage'] == null ? undefined : json['allowSeparateStorage'],
        'storageMethodOptions': json['storageMethodOptions'] == null ? undefined : ((json['storageMethodOptions'] as Array<any>).map(EnumOptionFromJSON)),
        'targetBoxOptions': json['targetBoxOptions'] == null ? undefined : ((json['targetBoxOptions'] as Array<any>).map(TargetBoxOptionFromJSON)),
    };
}

export function AdminStockAdjustLocationMoveInitResVoToJSON(json: any): AdminStockAdjustLocationMoveInitResVo {
    return AdminStockAdjustLocationMoveInitResVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveInitResVoToJSONTyped(value?: AdminStockAdjustLocationMoveInitResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'goodsId': value['goodsId'],
        'batchNo': value['batchNo'],
        'sourceBoxId': value['sourceBoxId'],
        'sourceMarkNo': value['sourceMarkNo'],
        'sourceSeparateStore': value['sourceSeparateStore'],
        'adjustableQty': value['adjustableQty'],
        'allowSeparateStorage': value['allowSeparateStorage'],
        'storageMethodOptions': value['storageMethodOptions'] == null ? undefined : ((value['storageMethodOptions'] as Array<any>).map(EnumOptionToJSON)),
        'targetBoxOptions': value['targetBoxOptions'] == null ? undefined : ((value['targetBoxOptions'] as Array<any>).map(TargetBoxOptionToJSON)),
    };
}

